export default __webpack_public_path__ + "static/media/casal_8.122729ab.jpg";